<template>
  <v-row>
    <v-col cols="12">
      <v-text-field
        v-model="result.imageHeight"
        label="Kép magasság"
        outlined
        dense
      ></v-text-field>
    </v-col>
    <v-col cols="12">
      <input type="file" @change="onFileChange" />
      <img v-if="imageUrl" :src="imageUrl" :style="{ height: result.imageHeight + 'px' }" alt="Uploaded Image" :disabled="result.name != ''"/>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: 'ImageComponent',
  data() {
    return {
      imageUrl: null,
      formData: new FormData(),
      result: {
        name: '',
        imgSrc: '',
        imageHeight: '', // Initialize the imageHeight property
        file: null,
      },
    };
  },
  emits: ['formAddEvent'],
  methods: {
    sendDataToParent() { 
      const dataToSend = {
        name: this.result.name,
        imgSrc: this.result.imgSrc,
        imageHeight: this.result.imageHeight,
        file: this.result.file,
      }
      this.$emit('formAddEvent', dataToSend);
    },
    async onFileChange(event) {
      this.result.file = event.target.files[0];
      this.sendDataToParent()
      
    },
  },
};
</script>

<style>
img {
  max-width: 100%;
  height: auto;
}
</style>
